// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"6f38e0b1862a8b4b","6831":"3b4e504dffc34038","8503":"edbc041005412d4a","9683":"f313a9a9cc733aa4"}[chunkId] + ".js";
};